import { createSelector } from 'reselect'

export const stateSelector = state => state.api.get.all.meetings_feedbacks

export const data = () =>
  createSelector(
    [stateSelector],
    state => state.data
  )

export const isLoading = () =>
  createSelector(
    [stateSelector],
    state => state.isLoading
  )
